module.exports = __webpack_public_path__ + "img/goods-hk.752a98f6.png";